import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from './cn';

const base =
  'inline-flex items-center justify-center gap-2 font-semibold rounded-xl ' +
  'transition-all duration-150 focus:outline-none focus-visible:ring-2 ' +
  'focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background ' +
  'disabled:opacity-60 disabled:cursor-not-allowed active:scale-[0.98] select-none';

const variants = {
  primary:
    'gradient-brand text-white shadow-md hover:shadow-lg hover:brightness-110',
  secondary:
    'bg-surface text-foreground border border-border hover:bg-surface-2 shadow-sm',
  outline:
    'bg-transparent text-brand border border-brand/40 hover:bg-brand-soft',
  ghost:
    'bg-transparent text-muted hover:bg-surface-2 hover:text-foreground',
  danger:
    'bg-status-canceled text-white shadow-sm hover:brightness-110',
};

const sizes = {
  sm: 'text-xs px-3 py-1.5',
  md: 'text-sm px-4 py-2.5',
  lg: 'text-base px-5 py-3',
  icon: 'p-2.5',
};

const Button = React.forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    className,
    children,
    loading = false,
    icon: Icon,
    iconRight = false,
    disabled,
    type = 'button',
    ...props
  },
  ref
) {
  const content = (
    <>
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        Icon && !iconRight && <Icon className="h-4 w-4" />
      )}
      {children}
      {!loading && Icon && iconRight && <Icon className="h-4 w-4" />}
    </>
  );

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(base, variants[variant], sizes[size], className)}
      {...props}
    >
      {content}
    </button>
  );
});

export default Button;
